import React from 'react';
import ThreadItem from '../ThreadItem';

const Conversations = ({ conversations, activeKey, user }) => {
  return conversations.map((convo) => (
    <ThreadItem
      user={user}
      active={activeKey === convo.convo_id}
      key={convo.convo_id}
      {...convo}
    />
  ));
};

export default Conversations;
